import {FC} from "react";
import {ListItemText} from "../Menu.tsx";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import HomeIcon from "@mui/icons-material/Home";
import {useRouter} from "../../hooks/useRouter.ts";

const HomeButton: FC = () => {
    const {gotoHome} = useRouter()

    return (
        <ListItem disablePadding>
            <ListItemButton onClick={gotoHome}>
                <ListItemIcon>
                    <HomeIcon/>
                </ListItemIcon>
                <ListItemText primary="Home"/>
            </ListItemButton>
        </ListItem>
    )
}

export default HomeButton
